import React from 'react'
import { Link } from 'react-router-dom'
import QuantityControl from '../helper/QuantityControl'
import CartList from './CartList'

const CartSection = ({items, totalSummary}) => {
    return (
        <section className="cart py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-xl-9 col-lg-8">
                        <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
                            <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                                <table className="table style-three">
                                    <thead>
                                        <tr>
                                            <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Product Name</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Price</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Quantity</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items?.length > 0 ? (
                                            items?.map(item => <CartList key={item?.id} item={item}  />)
                                        ) : 
                                            <tr>
                                                <td colSpan={5} className='text-center'>
                                                    Cart proudct not found
                                                </td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                            {
                                items?.length > 0 && (
                                    <div className="flex-between flex-wrap gap-16 mt-16">
                                        <div className="flex-align gap-16">
                                            <input
                                                type="text"
                                                className="common-input"
                                                placeholder="Coupon Code"
                                            />
                                            <button
                                                type="submit"
                                                className="btn btn-main py-18 w-100 rounded-8"
                                            >
                                                Apply Coupon
                                            </button>
                                        </div>
                                        <button
                                            type="submit"
                                            className="text-lg text-gray-500 hover-text-main-600"
                                        >
                                            Update Cart
                                        </button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4">
                        <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
                            <h6 className="text-xl mb-32">Cart Totals</h6>
                            <div className="bg-color-three rounded-8 p-24">
                                <div className="mb-32 flex-between gap-8">
                                    <span className="text-gray-900 font-heading-two">Subtotal</span>
                                    <span className="text-gray-900 fw-semibold">{totalSummary?.subtotal && `৳ ${totalSummary?.subtotal}`}</span>
                                </div>
                                <div className="mb-0 flex-between gap-8">
                                    <span className="text-gray-900 font-heading-two">
                                        Extimated Taxs
                                    </span>
                                    <span className="text-gray-900 fw-semibold">{totalSummary?.tax &&  `৳ ${totalSummary?.tax}`}</span>
                                </div>
                            </div>
                            <div className="bg-color-three rounded-8 p-24 mt-24">
                                <div className="flex-between gap-8">
                                    <span className="text-gray-900 text-xl fw-semibold">Total</span>
                                    <span className="text-gray-900 text-xl fw-semibold">{totalSummary?.grand_total && `৳ ${totalSummary?.grand_total}`}</span>
                                </div>
                            </div>
                            <Link
                                to="/checkout"
                                className="btn btn-main mt-40 py-18 w-100 rounded-8"
                            >
                                Proceed to checkout
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default CartSection